import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Report } from '@app/shared/features/reports/models/report.model';
import { ReportGroup } from '../../models/report-group.model';
import { PowerBiFilterData } from '@app/shared/components/power-bi/models/power-bi-data.model';

export interface ReportSelection {
  report: Report;
  quarter: string;
}

@Component({
  selector: 'app-reports-page',
  templateUrl: './reports-page.component.html',
  styleUrls: ['./reports-page.component.scss']
})
export class ReportsPageComponent implements OnChanges {

  @Input() reports: ReportGroup[] = [];
  @Input() currentReport?: Report;
  @Input() isMultiPageReport = false;
  @Input() filtersData: PowerBiFilterData[] = [];
  @Input() slicersData: PowerBiFilterData[] = [];
  @Input() quarterTableName: string = null;
  @Input() quartersOfYear: { label: string; value: string }[] = [];

  @Output() reportSelected = new EventEmitter<ReportSelection>();

  selectedQuarter = '';

  public ngOnChanges() {
    if (this.quartersOfYear?.length && !this.selectedQuarter) {
      this.selectedQuarter = this.quartersOfYear[0].value;
    }
  }

  selectReport(report: Report): void {
    this.reportSelected.emit({ report, quarter: this.selectedQuarter });
  }

  onQuarterChange(quarter: string): void {
    this.selectedQuarter = quarter;

    if (this.currentReport) {
      this.reportSelected.emit({ report: this.currentReport, quarter });
    }
  }
}